module.exports = __webpack_public_path__ + "img/discord.8f1a69fb.svg";